export default __webpack_public_path__ + "static/media/icon.7f92f751.svg";